// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"9ccbbe3def1e751ae980","655":"038002869ab86217b63d"}[chunkId] + ".js";
};